import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ArticleEditorForm from '../../components/ArticleEditorForm';
import { portalApi } from '../../utils/portalApi';

export default function ArticleEditorPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [initialArticle, setInitialArticle] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const isEdit = Boolean(slug);

  useEffect(() => {
    if (!isEdit) return;
    portalApi
      .listAdminArticles()
      .then((data) => {
        const found = (data.articles || []).find((item) => item.slug === slug);
        if (!found) {
          setError('Article not found.');
          return;
        }
        setInitialArticle(found);
      })
      .catch((err) => setError(err.message));
  }, [isEdit, slug]);

  const handleSave = async (article) => {
    setBusy(true);
    setError('');
    try {
      await portalApi.saveArticle({ ...article, originalSlug: initialArticle?.slug });
      navigate('/articles');
    } catch (err) {
      setError(err.message || 'Unable to save article');
    } finally {
      setBusy(false);
    }
  };

  return (
    <section>
      <div className="mb-4 flex items-center justify-between gap-3">
        <h1 className="text-2xl font-semibold text-slate-900">{isEdit ? 'Edit Article' : 'Create New Article'}</h1>
        <Link to="/articles" className="text-sm text-cam-blue hover:underline">Back to articles</Link>
      </div>
      {error ? <p className="mb-4 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">{error}</p> : null}
      <ArticleEditorForm
        initialArticle={initialArticle}
        onSubmit={handleSave}
        busy={busy}
        submitLabel={isEdit ? 'Save Changes' : 'Create Article'}
      />
    </section>
  );
}
